import React from 'react';
import { motion } from 'framer-motion';

export const OnboardingWelcome = ({ userName }) => {
  const firstName = (userName || 'there').split(' ')[0];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center justify-center min-h-[55vh] px-6 text-center"
      data-testid="onboarding-welcome"
    >
      <div className="max-w-sm">
        <p className="text-2xl font-light text-slate-900 leading-relaxed mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Hi {firstName}.<br />
          <span className="font-medium">I'm Kindra.</span>
        </p>

        <div className="space-y-4 text-base text-slate-600 leading-relaxed text-left">
          <p>
            I'm here to help you understand your health, track what's happening, and prepare for appointments.
          </p>
          <p>
            This will only take a few minutes. You can skip anything and come back anytime.
          </p>
        </div>

        <p className="mt-8 text-xs text-slate-400">
          Everything here is private and editable. Kindra is a health companion, not a diagnosis tool.
        </p>
      </div>
    </motion.div>
  );
};
